import axios, { AxiosResponse } from 'axios';
import { ApiResponse, zps_ms_ea_war } from '../../zps';

export type ICommand = {
  arid: number;
  cid: number;
  command: number;
  commandId: number;
  datetime: string;
  did: number;
  dmid: number;
  eid: number;
  eidKey: number;
  entid: number;
  etid: number;
  gid: number;
  gidKey: number;
  lid: number;
  movid: number;
  operation: number;
  posid: number;
  sid: number;
  uid: number;
};

export interface CommandsResponse extends ApiResponse {
  list: ICommand[];
  totalRows: number;
}

export const fetchSyncCommands = (
  controller: AbortController,
  offset: number,
  limit: number,
  totalRows: boolean,
  begin?: string | null,
  end?: string | null,
  entid?: number,
  eid?: number
): Promise<AxiosResponse<CommandsResponse>> => {
  const url =
    `${zps_ms_ea_war}/synccommand?&offset=${offset}&limit=${limit}&totalRows=${totalRows}` +
    (begin ? `&begin=${begin}` : '') +
    (end ? `&end=${end}` : '') +
    (entid ? `&entid=${entid}` : '') +
    (eid ? `&eid=${eid}` : '');

  return axios.get<CommandsResponse>(url, { signal: controller.signal }).catch(error => {
    console.error('Failed to fetch sync commands:', error);
    throw error;
  });
};

export const deleteSyncCommands = (commandId: number): Promise<AxiosResponse<CommandsResponse>> => {
  return axios.delete<CommandsResponse>(`${zps_ms_ea_war}/synccommand?&commandId=${commandId}`).catch(error => {
    console.error('Failed to delete sync command:', error);
    throw error;
  });
};
